import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';

import { RouteFragment } from '../shared/common';

import { AuthService } from './auth.service';

export const isUserSignedIn: CanActivateChildFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isSignedIn() ? true : router.createUrlTree(['/', RouteFragment.SignIn]);
};

export const isUserSignedOut: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isSignedOut() ? true : router.createUrlTree(['/', RouteFragment.Main]);
};
